module.exports = __webpack_public_path__ + "img/catacomb.61ffa046.jpeg";